import { render, staticRenderFns } from "./UsageCardView.vue?vue&type=template&id=90c493e2"
import script from "./UsageCardView.vue?vue&type=script&lang=js"
export * from "./UsageCardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports